import React from "react";
import "../../App.css";

function Julieta() {
  return (
    <div className="aboutus-container">
      <h1 className="about-us">Julieta Lambanao</h1>
          <div class="aboutus-info">
          <div class="row">
            <div class="column">
              <div class="profileimg">
                <img src="images/julie.jpg" alt="Julieta"></img>
              </div>
            </div>
            <div class="column">
            <div class="aboutus-offer">
              <p><strong>TERTIARY QUALIFICATION</strong></p>
              <p class="tab">
              <ul>
                <li>Dr. of Public Administration- Graduated 1995 MLQU Philippines- with Dissertation in satellite
technology status in the Philippines</li>
                <li>Bachelor of Public Administration - Leadership Medal Awards</li>
              </ul>
              </p>
              <strong>AUSTRALIA</strong>
              <p class="tab">
              <ul>
                <li>Assessed by: Overseas Qualification Unit- Master’s degree equivalent to: Australian Bachelor
Degree</li>
              </ul>
              </p>
              <strong>EDUCATIONAL QUALIFICATION AUSTRALIA</strong>
              <p class="tab">
              <ul>
                <li>Certificate IV in Training and Assessment- Graduated at Vic Uni (2009)</li>
                <li>Certificate IV in Second Language Teaching- Finished (for Community Teacher’s 
                  Certificate requirement)</li>
                <li>Graduate Diploma in TESOL- Unfinished yet</li>  
                <li>Successive trainings for Victorian Teachers Qualifications FOR VCE TEACHERS</li>
                <li>Certificate III in Small Business Management- Finished Year 2000</li>
              
              </ul>
              </p>
             
              
              
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Julieta;
